import React, { useState } from 'react';

const getCanvaEmbedUrl = (url) => {
  if (!url) return '';
  const basePath = url.split('?')[0];
  return `${basePath}?embed&autoplay=1&muted=1`;
};

const FaqsView = () => {
  const zones = [
    { id: 1, category: 'LOCKER', label: 'Taquilla', x: '40%', y: '18%',           video_x: '-58%', video_y: '20%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 2, category: 'SCREEN', label: 'Pantalla', x: '31%', y: '32%',           video_x: '-58%', video_y: '50%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 3, category: 'DOOR', label: 'Puerta', x: '31%', y: '45%',               video_x: '-58%', video_y: '80%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 4, category: 'TICKET', label: 'Ticket', x: '50%', y: '44%',             video_x: '90%',  video_y: '20%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
    { id: 5, category: 'PAYMENTS', label: 'Pago con tarjeta', x: '70%', y: '44%', video_x: '90%',  video_y: '80%', url: 'https://www.canva.com/design/DAHDdlrgVsE/5eUMmf-khOQVFtS-IGwp9w/watch?utm_content=DAHDdlrgVsE&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h54ec37cc96' },
  ];

  const categories = Array.from(new Set(zones.map(z => z.category)));

  // null = all visible; string = only that category visible
  const [activeCategory, setActiveCategory] = useState(null);

  const selectCategory = (cat) => {
    setActiveCategory(prev => (prev === cat ? null : cat));
  };

  const categoryIcons = {
    LOCKER: '🔒',
    SCREEN: '🖥️',
    DOOR: '🚪',
    TICKET: '🎫',
    PAYMENTS: '💳',
  };

  return (
    <div style={{ display: 'flex' }}>
      {/* Sidebar Menu */}
      <div style={{
        width: '240px',
        minWidth: '240px',
        padding: '24px 16px',
        background: '#f8f9fb',
        borderRight: '1px solid #e4e7ec',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}>
        <h1 className="mt-2 mb-1 text-vw-dark" style={{ fontSize: '18px', fontWeight: 700 }}>FAQS VIDEOS</h1>
        <p className="mb-4 text-vw-light" style={{ fontSize: '13px', lineHeight: '1.4' }}>
          Selecciona una categoría para filtrar los vídeos.
        </p>

        {/* All button */}
        <button
          onClick={() => setActiveCategory(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 14px',
            border: '2px solid',
            borderColor: activeCategory === null ? '#001d3a' : '#dde1e7',
            borderRadius: '10px',
            backgroundColor: activeCategory === null ? '#001d3a' : '#fff',
            color: activeCategory === null ? '#fff' : '#556',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '13px',
            transition: 'all 0.15s',
          }}
        >
          <span>🎬</span> TODOS
        </button>

        <div style={{ height: '1px', background: '#e4e7ec', margin: '4px 0' }} />

        {categories.map(cat => {
          const isActive = activeCategory === cat;
          return (
            <button
              key={cat}
              onClick={() => selectCategory(cat)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '10px 14px',
                border: '2px solid',
                borderColor: isActive ? '#ffae00' : '#dde1e7',
                borderRadius: '10px',
                backgroundColor: isActive ? '#fff8e6' : '#fff',
                color: isActive ? '#001d3a' : '#556',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '13px',
                transition: 'all 0.15s',
                boxShadow: isActive ? '0 2px 8px rgba(255,174,0,0.25)' : 'none',
              }}
            >
              <span>{categoryIcons[cat] || '▶'}</span>
              {cat}
              {isActive && (
                <span style={{ marginLeft: 'auto', color: '#ffae00', fontSize: '10px' }}>●</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Machine Image + Zones */}
      <div className="machine-container" style={{ position: 'relative', flex: 1 }}>
        <img src="/images/machines/big.png" alt="Machine" style={{ width: '100%' }} />

        {zones.filter(z => activeCategory === null || z.category === activeCategory).map(zone => {
          const embedUrl = getCanvaEmbedUrl(zone.url);

          return (
            <div key={zone.id}>
              {/* Zone Dot */}
              <div
                className="zone-dot"
                style={{ top: zone.y, left: zone.x, transform: 'translate(-50%, -50%)' }}
              />

              {/* Connector Line */}
              <svg
                className="connector-line"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              >
                <line
                  x1={zone.x}
                  y1={zone.y}
                  x2={zone.video_x}
                  y2={zone.video_y}
                  stroke="#ffae00"
                  strokeWidth="2"
                />
              </svg>

              {/* Video Container */}
              <div
                className="video-container"
                style={{
                  position: 'absolute',
                  top: zone.video_y,
                  left: zone.video_x,
                  transform: 'translateY(-50%)',
                  background: '#fff',
                  border: '1px solid #ccc',
                  padding: '10px',
                  width: '320px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  zIndex: 20,
                }}
              >
                <div style={{ marginBottom: '8px', fontWeight: 'bold', color: '#000' }}>{zone.label}</div>
                <iframe
                  width="100%"
                  height="180"
                  src={embedUrl}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqsView;
